import { app } from "router/routes"
import { useCallback } from "react"
import { useSelector } from "react-redux"
import { useNavigate, useParams } from "react-router-dom"

const useMatchingLeraningBtn = (id) => {
    const navigate = useNavigate()
    const params = useParams()

    const { assessment } = useSelector(state => state.assessment)
    const assessmentID = assessment.id || params?.assessmentID || id

    const goMatchingLeraning = useCallback(() => {
        navigate(`${app.matchingLearning}/${assessmentID}`)
    }, [])

    const matchingLeraningBtn = {
        label: "קריאה מותאמת",
        action: goMatchingLeraning,
        height: '35px',
        fontsize: 16
    }

    return matchingLeraningBtn
}

export default useMatchingLeraningBtn